// SPDX-FileCopyrightText: 2025 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF

import { QCResult } from 'components/project/data/filter/filters-defaults';
import { useEffect, useState } from 'react';

type LabelSummary = {
  goodProcessCount: number;
  badProcessCount: number;
  undefinedProcessCount: number;
  evaluationSetCount: number;
  unlabeldCount: number;
  traingSetCount: number;
};

const initState = {
  goodProcessCount: 0,
  badProcessCount: 0,
  undefinedProcessCount: 0,
  traingSetCount: 0,
  evaluationSetCount: 0,
  unlabeldCount: 0,
};

export default function useLabelSummary(labels) {
  const [labelSummary, setLabelSummary] = useState<LabelSummary>(initState);

  useEffect(() => {
    const newFooterState = { ...initState };
    labels.forEach(label => {
      if (label.hasMask) {
        switch (label.qcResult) {
          case QCResult.Good:
            newFooterState.goodProcessCount++;
            break;
          case QCResult.Bad:
            newFooterState.badProcessCount++;
            break;
          default:
            newFooterState.undefinedProcessCount++;
            break;
        }
        if (label.isValidation) {
          newFooterState.evaluationSetCount++;
        } else {
          newFooterState.traingSetCount++;
        }
      } else {
        newFooterState.unlabeldCount++;
      }
    });
    setLabelSummary(newFooterState);
  }, [labels, setLabelSummary]);

  return labelSummary;
}
